import { useSelector } from 'react-redux'
import { selectToken } from '../authentication/authenticationSlice'
import api, { isHTTPError } from '../api'
import useDataLoader from '../dataLoader'

const useGetNotificationToken = (organizationId: number | null) => {
  const token = useSelector(selectToken)
  const getApiToken = async () => {
    if (organizationId) {
      try {
        return await api.getNotificationToken({ token, organizationId })
      } catch (error) {
        if (isHTTPError(error) && error.response.status === 404) {
          return null
        } else if (isHTTPError(error) && 'detail' in error.response.data) {
          throw new Error(
            'Error loading api token: ' + error.response.data.detail.type
          )
        } else {
          throw error
        }
      }
    }
  }

  return useDataLoader(getApiToken, [], [])
}

export default useGetNotificationToken
